/*
 * Module for the Summary step of the DROP Distribution Election form
*/
rs.module("ui/content/communications/onlineforms/summary",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (selectHelper, eventBanner, visibility) {
        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var accordion = stepContainer.js(jsSelectors.accordion, { multiple: true });
            var agreementFlags = stepContainer.js(jsSelectors.agreementFlag, { multiple: true });
            var form = stepContainer.closest("form");

            // Ensure validation sees hidden flags
            agreementFlags.each(function () {
                $.validator.include.list.push("#" + this.id);
            });

            // Run validation on finish
            form.on("submit", function (e) {

                var submitter = e.originalEvent.submitter;

                // Only validate if Finish (_next) was clicked
                if (!submitter || !$(submitter).is('[data-js="_next"]')) {
                    return;
                }

                if (form.valid()) {
                    return;
                }
                e.preventDefault();

                // Open first error and scroll to it
                openFirstErrorAccordionAndScroll()
            });

            // Handle summary click event
            accordion.each(function () {

                var details = $(this);
                var summary = details.find("summary");

                summary.on("click", function (e) {
                    e.preventDefault();

                    showSelectedAccordion(details);

                    scrollToAccordion(details);
                });
            });

            // Handle agreement flag click event
            agreementFlags.on("change", function () {

                var checkbox = $(this);

                if (!checkbox.is(":checked")) {
                    return;
                }

                var currentAccordion = checkbox.closest("details");
                var nextAccordion = getNextAccordion(currentAccordion);

                closeAccordion(currentAccordion);

                if (nextAccordion.length) {
                    openAccordion(nextAccordion);
                }
            });

            // Show (slide down) the selected accordion
            function showSelectedAccordion(selectedAccordion) {

                var isOpen = selectedAccordion.attr("open");

                // Close other accordions
                closeOtherAccordions(selectedAccordion);

                // If this one was already open, close and stop here
                if (isOpen) {
                    closeAccordion(selectedAccordion);
                    return;
                }

                // Open selected
                openAccordion(selectedAccordion);
            }

            // Open the first accordion with an error and scroll so it is in view
            function openFirstErrorAccordionAndScroll() {
                // Find first invalid field
                var firstError = form.find(".input-validation-error").first();

                if (!firstError.length) {
                    return;
                }

                // Find its accordion
                var targetAccordion = firstError.closest("details");

                if (targetAccordion.length) {

                    // Close all other accordions
                    closeOtherAccordions(targetAccordion);

                    // Open the one with the error
                    openAccordion(targetAccordion);
                }

                // Scroll to the field
                scrollToAccordion(firstError);
            }

            // Open the current accordion
            function openAccordion(details) {
                var content = details.find(".slide-content");

                details.attr("open", "open");
                content.stop(true, true).slideDown({
                    duration: 350,
                    easing: "swing"
                });

            }

            // Close the current accordion
            function closeAccordion(details) {
                var content = details.find(".slide-content");

                content.stop(true, true).slideUp({
                    duration: 300,
                    easing: "swing",
                    complete: function () {
                        details.removeAttr("open");
                    }
                });
            }

            // Close all accordions other than selected
            function closeOtherAccordions(selectedAccordion) {
                accordion.not(selectedAccordion).each(function () {
                    closeAccordion($(this));
                });
            }

            // Find the accordion after the currently selected one (if applicable)
            function getNextAccordion(currentAccordion) {
                return accordion.eq(accordion.index(currentAccordion) + 1);
            }

            // Scroll to the selected accordion
            function scrollToAccordion(details) {

                // Define scroll distance based on device size
                var top = details.offset().top;
                var scrollTop = $(window).scrollTop();
                var viewportHeight = $(window).height();

                var threshold = window.innerWidth < 768
                    ? viewportHeight / 3   // mobile (scroll more)
                    : viewportHeight;      // desktop (rarely scroll)

                // If already mostly visible, do nothing
                if (top > scrollTop && top < scrollTop + threshold) {
                    return;
                }

                // Scroll animation
                setTimeout(function () {
                    $("html, body").animate({
                        scrollTop: details.offset().top - 160
                    }, {
                        duration: 600, // how long the scroll takes
                        easing: "swing"
                    }
                    );
                }, 250); // time before scroll begins
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);